import styled from "styled-components";

export const TestimonialWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    position: relative;
    bottom: 20px;
  }
`;
